import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import SignupForm from '../../../components/Authentication/SignupForm';
import { Helmet } from 'react-helmet';

export default function IndexSignUp() {

    useEffect(() => {
        // Mettre à jour le titre de la page
        document.title = "Création de compte organisateur - Events";
        
    }, []);

    return (
        <>
            <Helmet>
                <title>Inscription Organisateur - Devenez Organisateur d'Événements | Events CI</title>

                <meta
                name="description"
                content="Inscrivez-vous gratuitement et devenez organisateur sur Events. Publiez vos événements, gérez vos ventes de billets et atteignez un large public grâce à notre plateforme de billetterie événementielle en Côte d'Ivoire."
                />

                <meta
                name="keywords"
                content="inscription organisateur Events, créer compte organisateur événementiel, publier événement Côte d'Ivoire, billetterie événementielle Afrique, gestion événements Abidjan, plateforme événementielle CI"
                />

                <meta name="author" content="Events" />

                {/* Open Graph */}
                <meta property="og:title" content="Inscription Organisateur - Devenez Organisateur d'Événements | Events CI" />
                <meta
                property="og:description"
                content="Inscrivez-vous gratuitement et devenez organisateur sur Events. Publiez vos événements, gérez vos ventes de billets et atteignez un large public grâce à notre plateforme de billetterie événementielle en Côte d'Ivoire."
                />
                <meta property="og:image" content="https://eventsbilletterie.com/assets/images/mainpage-organizer-dashbord.png" />
                <meta property="og:url" content="https://eventsbilletterie.com/create-account" />
                <meta property="og:type" content="website" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Inscription Organisateur - Devenez Organisateur d'Événements | Events CI" />
                <meta
                name="twitter:description"
                content="Inscrivez-vous gratuitement et devenez organisateur sur Events. Publiez vos événements, gérez vos ventes de billets et atteignez un large public grâce à notre plateforme de billetterie événementielle en Côte d'Ivoire."
                />
                <meta name="twitter:image" content="https://eventsbilletterie.com/assets/images/mainpage-organizer-dashbord.png" />
                <meta name="twitter:site" content="@events_billetterie" /> {/* Remplace par ton handle Twitter si applicable */}

                {/* Canonical URL */}
                <link rel="canonical" href="https://eventsbilletterie.com/create-account" />
            </Helmet>
            
            <div className="nc-PageLogin " data-nc-id="PageLogin">
                <div className="container mb-24 lg:mb-32">
                    <h2 className="my-10 mb-5 flex items-center text-center text-2xl leading-[115%] md:text-3xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
                        Devenir organisateur Events
                    </h2>
                    <div className="relative text-center max-w-3xl mx-auto space-y-11">
                        <span className="relative inline-block px-4 text-sm bg-white dark:text-neutral-400 dark:bg-neutral-900">
                            Accédez à des outils performants pour publier et gérer vos événements en toute simplicité. Suivez vos réservations, consultez vos statistiques en temps réel, et profitez d'une gestion optimisée de vos événements.
                        </span>
                    </div>
                    <div className="max-w-3xl mx-auto space-y-6 mt-12">

                    <SignupForm />
                        
                    <span className="block text-center text-neutral-700 dark:text-neutral-300">
                        Déjà un compte?{' '} <Link to="/login" className='font-medium text-primary-6000'>Connectez-vous ici</Link>
                    </span>
                    </div>
                </div>
            </div>
        </>
    )
}
